<template>
  <div>
    <page-header
      title="Input VAT"
      breadcrumb="Settings > Accounting > Tax > Output VAT"
    />

    <div class="bg-white p-3">
      <div
        class="border-b-2 border-gray-200 py-2 flex justify-between items-center"
      >
        <p class="flex justify-center items-center">
          <b>Input VAT</b>
          <el-date-picker placeholder="October, 2020" class="mt-3 ml-4" />
        </p>
        <img src="@/assets/images/icons/info.svg" alt="information icon" />
      </div>

      <div class="flex items-center justify-between py-2">
        <span class="text-primary-yellow flex items-center"></span>
        <span
          ><small>Tax: </small>
          <abbr class="text-primary-yellow text-base">₦ 19,107,060</abbr></span
        >
      </div>

      <div>
        <tax-output-table />
        <PaginationControl
          :total="totalCollection"
          :pageNumber="sortOptions.pageNumber"
          @pageNumber="setPageDisplayCollection"
          @pageSize="setNumDisplayCollection"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";
import TaxOutputTable from "@/components/3pl/Accounting/Tax/TaxOutputTable.vue";

export default {
  components: { PageHeader, TaxOutputTable, PaginationControl },
  data() {
    return {
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
    };
  },
  methods: {
    setNumDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplayCollection(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.sortOptions = { ...this.sortOptions, ...val };
    },
  },
};
</script>

<style lang="scss" scoped></style>
